/* globals confirm, console, module, require, window */
/* jshint esversion:6, globalstrict:true */
'use strict';

const BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    FilterSetsListItem = require('./filterSetsListItem'),
    ModalDialog = require('./modalDialog'),
    user = require('../models/user'),
    configuration = require('../utilities/configuration'),
    templates = require('../utilities/handlebars').templates,
    helpers = require('../utilities/handlebars').helpers,
    EOL = null;

module.exports = Marionette.CollectionView.extend({
    attributes: {
        name: 'filterSetsList',
        class: 'filter-sets-list'
    },
    channels: {
        analytics: BackboneRadio.channel('analytics'),
        vaultOut: BackboneRadio.channel('vaultInterface:out')
    },
    childView: FilterSetsListItem,
    childViewContainer: 'select[name=filterSetsListItems]',
    events: {
        'change select': 'onChangeSelect',
        'click select':  'onClickSelect'
    },
    skipFilterSetSelect: false,
    tagName: 'div',
    template: templates.filterSetsList,
    ui: {
        select: 'select[name=filterSetsListItems]'
    },
    //
    clearSelection: function () {
        jQuery('select', this.$el)[0].selectedIndex = 0;
    },
    initialize: function () {
        this.listenTo(this.collection, 'reset remove', _.bind(function () {
            this.render();
            if (this.collection.length) {
                _.defer(_.bind(function () {
                    jQuery('select option[value=launchSignIn]', this.$el).prop('disabled',  true);
                }, this));
            }
        }, this));
        this.listenTo(this.collection, 'add', _.bind(function (model) {
            // show the newly added filterSet in the select control
            _.defer(_.bind(function () {
                jQuery('select', this.$el).val(model.id);
            }, this));
        }, this));
    },
    onChangeSelect: function () {
        const filterSetId = jQuery('select', this.$el).find(':selected').val();
        this.trigger('select:filterSet', filterSetId);
        return false;
    },
    onClickSelect: function () {
        if (!user.isSignedIn() && this.ui.select.val() === 'launchSignIn') {
            if (configuration.embedded) {
                this.channels.vaultOut.trigger('requestLogon');
            } else {
                this.modalDialog = new ModalDialog({template: templates.pleaseSignIn, templateContext: {}, modalModal: false});
            }
        }
    },
    // onRender: function () {
    //     console.log(this.$el);
    // },
    selectFilterSet: function (filterSetId) {
        jQuery('select', this.$el).val(filterSetId);
        this.trigger('select:filterSet', filterSetId);
    },
    skipFilterSetSelectOnReset: function (skip) {
        // @acavan! - vestigal code?
        this.skipFilterSetSelect = skip;
    }
});
